import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { SessionStorageService } from "ngx-webstorage";
import { PolizaEntity } from '../../../views/empresas/entities/polizas_cliente_entity';
import { VamTitularEntity } from '../../../views/vam/titulares/entities/vam_titulares_entity';

declare var jQuery: any;

@Injectable()
export class CabeceraVamTitularService {
    private url="login";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    consultaSegurosContratados(poliza: VamTitularEntity): Observable<VamTitularEntity> {
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarVAMTitByCed", body, options).map(this.extractData)
            .catch(this.handleError);                 
    }

    consultaEmpresa(codigo: number, ciudad: number): Observable<boolean[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultaEmpresa",options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraVAMTitulares/cabecera-vam-titulares.service.ts